/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Min_NightsInputs */

const en_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Stay (Nights)`)
};

const es_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estancia mínima (Noches)`)
};

const fr_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séjour minimum (Nuits)`)
};

const de_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestaufenthalt (Nächte)`)
};

const ja_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低宿泊日数`)
};

const zh_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最少起订晚数`)
};

const ar_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحد الأدنى للإقامة (ليالي)`)
};

const id_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lama Menginap Minimum (Malam)`)
};

const it_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soggiorno Minimo (Notti)`)
};

const ru_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный срок проживания (ночей)`)
};

const pt_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadia Mínima (Noites)`)
};

const ko_field_min_nights = /** @type {(inputs: Field_Min_NightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최소 숙박 일수`)
};

/**
* | output |
* | --- |
* | "Minimum Stay (Nights)" |
*
* @param {Field_Min_NightsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_min_nights = /** @type {((inputs?: Field_Min_NightsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Min_NightsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_min_nights(inputs)
	if (locale === "es") return es_field_min_nights(inputs)
	if (locale === "fr") return fr_field_min_nights(inputs)
	if (locale === "de") return de_field_min_nights(inputs)
	if (locale === "ja") return ja_field_min_nights(inputs)
	if (locale === "zh") return zh_field_min_nights(inputs)
	if (locale === "ar") return ar_field_min_nights(inputs)
	if (locale === "id") return id_field_min_nights(inputs)
	if (locale === "it") return it_field_min_nights(inputs)
	if (locale === "ru") return ru_field_min_nights(inputs)
	if (locale === "pt") return pt_field_min_nights(inputs)
	return ko_field_min_nights(inputs)
});